import { render, staticRenderFns } from "./coupon_edit.vue?vue&type=template&id=531d461a&"
import script from "./coupon_edit.vue?vue&type=script&lang=js&"
export * from "./coupon_edit.vue?vue&type=script&lang=js&"
import style0 from "./coupon_edit.vue?vue&type=style&index=0&id=531d461a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports